import { render, staticRenderFns } from "./Knowledge.html?vue&type=template&id=26ca5806&"
import script from "./Knowledge.ts?vue&type=script&lang=ts&"
export * from "./Knowledge.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/knowledge/_knowledge.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports